"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = require("../../services/store");
const actions = require("./actions");
class Abstract {
    constructor() {
        this.selectors = new Map([
            ['state', (state, rootState) => {
                    let isProcessing = false;
                    let errorMessage = null;
                    if (rootState.extensions.isProcessing.has(this.key)) {
                        isProcessing = rootState.extensions.isProcessing.get(this.key);
                    }
                    if (rootState.extensions.errorMessage.has(this.key)) {
                        errorMessage = rootState.extensions.errorMessage.get(this.key);
                    }
                    return { isProcessing, errorMessage };
                }],
        ]);
    }
    selector(key, props = {}) {
        if (!this.selectors.has(key)) {
            throw new Error('invalid selector name');
        }
        return (rootState) => {
            return this.selectors.get(key)(this.getExtensionStateFromRootState(rootState), rootState, props);
        };
    }
    dispatchRequest() {
        this.dispatch(actions.updateRequest(this.key));
    }
    dispatchFailure(errorMessage) {
        this.dispatch(actions.updateFailure(this.key, errorMessage));
    }
    dispatchSuccess(state) {
        this.dispatch(actions.updateSuccess(this.key, state));
    }
    dispatch(message) {
        store_1.store.dispatch(message);
    }
    updateState(func) {
        const oldState = this.getExtensionStateFromRootState(store_1.store.getState());
        const newState = func(oldState);
        this.dispatchSuccess(newState);
    }
    getExtensionStateFromRootState(rootState) {
        return rootState.extensions.state.has(this.key)
            ? rootState.extensions.state.get(this.key)
            : {};
    }
}
exports.Abstract = Abstract;
const Extensions = new Map();
function Register(e) {
    if (Extensions.has(e.key)) {
        throw new Error('can not register extension, key already being used');
    }
    Extensions.set(e.key, e);
    return e;
}
exports.Register = Register;
function Get(key) {
    if (!Extensions.has(key)) {
        throw new Error('can not get extension, does not exists');
    }
    return Extensions.get(key);
}
exports.Get = Get;
//# sourceMappingURL=repository.js.map